import { Button, ButtonVariant, Icon, Popover, Position } from '@blueprintjs/core'
import React from 'react'
import FieldInput from '.'
import IScalarForm, { VerticalType } from './interface/IScalarForm'

interface ISubMenuProps {
  subMenus?: IScalarForm[],
  on?: () => void
}
const SubMenu = ({ subMenus, on }: ISubMenuProps ) :React.ReactElement | null => {
  return !!subMenus && !!subMenus.length 
    ?
    <div className="w-100 d-flex flex-column align-items-end ">
      <Popover
        position={ Position.RIGHT_TOP }
        content={
          <div className='sub-menu-container overflow-y-auto' >
            <div className="container">
              {
                subMenus.map( (sb, i) =>  {
                  return <FieldInput
                    key={i} 
                    vertical={VerticalType.VERTICAL}
                    {...sb}
                  />
                } )
              }
            </div>
          </div>
        }
      >
        <Button variant={ButtonVariant.MINIMAL}>
          <Icon icon="more" />
        </Button>
      </Popover>
      {/* {
        
      }   */}
    </div>
    :
    null
}

export default SubMenu